import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SQWADService } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'fgb-photo-scramble-page',
  templateUrl: './photo-scramble-page.component.html',
  styleUrls: ['./photo-scramble-page.component.scss'],
})
export class PhotoScramblePageComponent implements OnInit {
  scrambleURL: string;
  screenType = ScreenType;
  LeaderboardType = 102;

  private destroyRef = inject(DestroyRef);

  constructor(private sqwadService: SQWADService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.scrambleLink();
  }

  launchGame(url: string) {
    this.sqwadService.sso(1, url);
  }

  scrambleLink() {
    this.translate
      .stream('scramble.url')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: string) => {
        this.scrambleURL = data;
      });
  }
}
